module.exports = __webpack_public_path__ + "static/media/Icon awesome-user-circle@2x.3ba39759.png";